import apiClient from "./apiClient";

const BASE = "/api/AccountHead";

// API returns accountID (no `id`) — alias it so list/edit/filter code using `.id` works.
const withId = (a) => ({ ...a, id: a.accountID });

export const getAccountHeads = async () => {
  const res = await apiClient.get(`${BASE}/all`);
  return { ...res, data: (res.data || []).map(withId) };
};
export const createAccountHead = (data) => apiClient.post(`${BASE}/save`, data);
export const updateAccountHead = (id, data) => apiClient.post(`${BASE}/save`, { ...data, accountID: id });
export const deleteAccountHead = () => Promise.reject(new Error("Delete not supported by API"));
